import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { FlickrCommentTemplate } from './variants/FlickrComment'
import { FlickrSlideTemplate } from './variants/FlickrSlide'

const commentVariant = {
  ...productRowVariantForPath('flickr', 2),
  Template: FlickrCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('flickr', 3),
  Template: FlickrSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('flickr')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
